import { EMBED_ROUTE_NAMES } from "@/constants/embed";

// DL-452 — Public routes for the Academy embed in Horizon.
// The whole embed surface (these routes, src/layouts/EmbedAcademy.vue,
// src/pages/Academy/Embed/, src/components/Academy/Embed/) is deleted with the native migration
// (DL-385..DL-398).
//
// No `meta.requires`: the global guard in src/router/index.js is opt-in, so a route that declares
// nothing passes cleanly. Horizon's users do not exist in the legacy Mongo, there is no session to
// ask for. `meta.embed` is the key the router's afterEach and Apollo's errorLink switch off on.
//
// Own chunk: the authenticated Academy shares `webpackChunkName: "wizard"` and drags that whole
// bundle along.
//
// IMPORTANT: in src/router/routes/index.js this file goes BEFORE `...functional`.
// functional.routes.js ends with the 404 aliased to `"*"`, and vue-router 3 matches in definition
// order.
const embed = [
  {
    path: "/embed/academy",
    name: EMBED_ROUTE_NAMES.HOME,
    meta: {
      layout: "EmbedAcademy",
      embed: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "embed-academy" */ "@/pages/Academy/Embed/EmbedAcademyHome.vue"
      ),
  },
  {
    path: "/embed/academy/curso/:documentId",
    name: EMBED_ROUTE_NAMES.COURSE,
    meta: {
      layout: "EmbedAcademy",
      embed: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "embed-academy" */ "@/pages/Academy/Embed/EmbedAcademyCourseContent.vue"
      ),
  },
  {
    // A collection opens with the same view as a course, exactly like the legacy routes
    // (guards.routes.js:493-527 reuses AcademyCourseContent.vue).
    path: "/embed/academy/coleccion/:documentId",
    name: EMBED_ROUTE_NAMES.COLLECTION,
    meta: {
      layout: "EmbedAcademy",
      embed: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "embed-academy" */ "@/pages/Academy/Embed/EmbedAcademyCourseContent.vue"
      ),
  },
  {
    path: "/embed/academy/coleccion/:collectionDocumentId/curso/:courseDocumentId",
    name: EMBED_ROUTE_NAMES.COLLECTION_COURSE,
    meta: {
      layout: "EmbedAcademy",
      embed: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "embed-academy" */ "@/pages/Academy/Embed/EmbedAcademyCollectionCourseContent.vue"
      ),
  },
];

export default embed;
